import React, { useEffect, useCallback } from 'react';
import styles from './Lightbox.module.css';

/**
 * Полноэкранный просмотрщик изображений в стиле majestic-rp:
 *  - тёмная подложка, кнопка-крестик в правом верхнем углу
 *  - стрелки слева/справа для навигации
 *  - закрытие на Esc/клик по фону, навигация на ←/→
 */
const Lightbox = ({ images, index, onClose, onPrev, onNext }) => {
  const handleKey = useCallback(
    (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft') onPrev();
      else if (e.key === 'ArrowRight') onNext();
    },
    [onClose, onPrev, onNext]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [handleKey]);

  if (index === null || index === undefined || !images || images.length === 0) return null;

  const src = images[index];

  return (
    <div className={styles.backdrop} onClick={onClose} role="dialog" aria-modal="true">
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label="Закрыть"
      >
        ×
      </button>

      <button
        type="button"
        className={`${styles.nav} ${styles.navLeft}`}
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        aria-label="Предыдущее"
      >
        ‹
      </button>

      <div className={styles.imgWrap} onClick={(e) => e.stopPropagation()}>
        <img src={src} alt="" className={styles.img} />
        <div className={styles.counter}>
          {index + 1} / {images.length}
        </div>
      </div>

      <button
        type="button"
        className={`${styles.nav} ${styles.navRight}`}
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        aria-label="Следующее"
      >
        ›
      </button>
    </div>
  );
};

export default Lightbox;
